import { cycloneApiClient } from '@/shared/api/core/axios-instance';

import { uploadLibraryInMockStore } from '@/entities/dag/api/_internal/dagMockStore';
import { shouldUseDagMockApi } from '@/entities/dag/api/_internal/shouldUseDagMockApi';
import type { UploadLibraryRequest, UploadLibraryResponse } from '@/entities/dag/domain/types';

export const uploadLibraryApi = async (request: UploadLibraryRequest): Promise<UploadLibraryResponse> => {
  if (shouldUseDagMockApi()) {
    return uploadLibraryInMockStore(request);
  }

  const response = await cycloneApiClient.post<UploadLibraryResponse>('/libraries/', request);
  return response.data;
};
